import React from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

const BotShowcase = () => {
  const showcaseByYear = {
    2021: [
      {
        id: 1,
        image: "/lovable-uploads/d42a3d14-81fd-404c-be3c-4c38ea2c4293.png",
        alt: "PROM/BUSD trading bot performance showing 41.85% profit",
        description: "PROM/BUSD : 41.85% or 2183 USDT bot profit in 1m 24d"
      },
      {
        id: 2,
        image: "/lovable-uploads/f4031670-6a24-443a-a14c-1fb6c30c9f68.png",
        alt: "TEL/USDT trading bot performance showing 45.04% profit",
        description: "TEL/USDT : 45.04% or 2174 USDT bot profit in 2m 16d"
      },
      {
        id: 3,
        image: "/lovable-uploads/e2a9885d-7b37-4b9d-b113-3cf5614f388f.png",
        alt: "TRAC/ETH trading bot performance showing 42.29% profit",
        description: "TRAC/ETH : 42.29% or $6759 ETH bot profit in 1m 7d - printed 1 ETH overnight!"
      }
    ],
    2022: [
      {
        id: 4,
        image: "/lovable-uploads/68a3ee9e-b8ca-434d-856b-41dead3a2a87.png",
        alt: "HFT/USDT trading bot performance showing 21.35% profit",
        description: "HFT/USDT : 21.35% or 1,055.49 USDT bot profit in 9 days"
      },
      {
        id: 5,
        image: "/lovable-uploads/10c22ee6-1999-4dd3-b189-5da9058a6521.png",
        alt: "LUNA2/USD trading bot performance showing 13.13% profit",
        description: "LUNA2/USD : 13.13% or 592.24 USDT bot profit in 1 day"
      },
      {
        id: 6,
        image: "/lovable-uploads/3838db9a-e066-4b3b-bb02-79a4eff1c58e.png",
        alt: "MNW/USDT trading bot performance showing 27.12% profit",
        description: "MNW/USDT : 27.12% or 1,367.75 USDT bot profit in 25 days"
      }
    ],
    2023: [
      {
        id: 7,
        image: "/lovable-uploads/82e10b27-83fe-42be-b0c7-51f9fd18fbb2.png",
        alt: "LINK/BTC trading bot performance showing 29.4% profit",
        description: "LINK/BTC : 29.4% or $1077 worth of BTC in 1m 18d"
      },
      {
        id: 8,
        image: "/lovable-uploads/532b930e-e304-4c77-983c-8b4329cc484a.png",
        alt: "MODEX/USDT trading bot performance showing 166.2% profit",
        description: "MODEX/USDT : 166.2% or $644 in 1m 6d"
      },
      {
        id: 9,
        image: "/lovable-uploads/d342b432-f24b-4b7d-b1a4-91c26a0c02cf.png",
        alt: "SOL/BTC trading bot performance showing 63.5% profit",
        description: "SOL/BTC : 63.5% or $2188 USD worth of BTC in 1m 24d"
      }
    ],
    2024: [
      {
        id: 10,
        image: "/lovable-uploads/f0613723-1f2c-4475-9685-790bc415238e.png",
        alt: "OPUL/USDT trading bot performance showing 88.44% profit",
        description: "OPUL/USDT : 88.44% total P&L, 105.07% or $1,405 bot profit in 25d"
      },
      {
        id: 11,
        image: "/lovable-uploads/66f2346f-854c-487a-8c13-6c793ab88302.png",
        alt: "ORNJ/USDT trading bot performance showing 153.1% profit",
        description: "ORNJ/USDT : 153.1% or $4,436 bot profit, 2.46% daily over 2m 2d"
      },
      {
        id: 12,
        image: "/lovable-uploads/e964c288-91ca-475a-ab3d-e1de2841bff9.png",
        alt: "PAAL/USDT trading bot performance showing $4,608 profit",
        description: "PAAL/USDT : $4,608 bot profit at 2.96% daily over 1m 11d"
      }
    ],
    2025: [
      {
        id: 13,
        image: "/lovable-uploads/aed29230-985e-46b5-b558-e834166ca577.png",
        alt: "UTK/USDT trading bot performance showing 46.7% profit",
        description: "UTK/USDT : 46.7% bot profit or 1,153 USDT at 1.92% daily over 24d 5h"
      },
      {
        id: 14,
        image: "/lovable-uploads/384d9d4f-1acb-4b56-a515-79b016ce45ad.png",
        alt: "PAAL/USDT trading bot performance showing 301% profit",
        description: "PAAL/USDT : 301% bot profit or 2,561 USDT at 2.64% daily over 3m 22d"
      },
      {
        id: 15,
        image: "/lovable-uploads/d617be5d-3fce-4deb-9b61-7d717af0a5ec.png",
        alt: "ZEUS/USDT trading bot performance showing 27% profit",
        description: "ZEUS/USDT : 27% profit or 978 USDT at 1.06% daily over 25d"
      }
    ]
  };

  return (
    <section id="example-bots" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Example Bots
          </h2>
        </div>
        
        {Object.entries(showcaseByYear).map(([year, bots]) => (
          <div key={year} className="mb-16">
            <h3 className="text-2xl font-semibold text-white mb-8 text-center">
              {year === "2022" ? "2022: the bear market from hell" : 
               year === "2023" ? "2023: Still the bear" : 
               year === "2024" ? "2024: bull incoming..." :
               year === "2025" ? "2025: not quite alt season yet..." : year}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {bots.map((bot) => (
                <Dialog key={bot.id}>
                  <DialogTrigger asChild>
                    <div className="group bg-accent/5 rounded-lg border border-border hover:border-primary/50 transition-all duration-300 overflow-hidden hover:shadow-lg hover:shadow-primary/10 cursor-pointer">
                      <div className="aspect-video bg-muted/20 relative overflow-hidden">
                        <img
                          src={bot.image}
                          alt={bot.alt}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      </div>
                      <div className="p-4">
                        <p className="text-white text-sm font-medium text-center leading-relaxed">
                          {bot.description}
                        </p>
                      </div>
                    </div>
                  </DialogTrigger>
                  <DialogContent className="max-w-4xl w-full max-h-[90vh] p-2 bg-black border-black">
                    <div className="relative w-full h-full flex items-center justify-center">
                      <img
                        src={bot.image}
                        alt={bot.alt}
                        className="max-w-full max-h-full object-contain border-4 border-black"
                      />
                    </div>
                  </DialogContent>
                </Dialog>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BotShowcase;